import React, { ReactNode } from 'react';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    children: ReactNode;
    showIcon?: boolean;
    showOpen?: boolean;
}

const SectionTitle = ({ children, showIcon, showOpen }: Props) => (
    <div className="flex h-6 grow items-center rounded-sm ps-2">
        <div className="w-full text-xs font-bold text-gray-800">{children}</div>
        {showIcon ? (
            <Icon
                iconKey={showOpen ? 'arrow_down' : 'arrow_right'}
                className="text-gray-400 rtl:scale-x-[-1]"
            />
        ) : null}
    </div>
);

export default SectionTitle;
